
import React, { useEffect, useState } from "react";
import axios from "axios";
import apiConfig from "../../../apiConfig";

const AdminWallet = () => {
    const [walletData, setWalletData] = useState({
        currentBalance: 0,
        holdBalance: 0,
        totalCredits: 0,
        totalDebits: 0,
        transactions: [],
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchWallet();
    }, []);

    const fetchWallet = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${apiConfig.baseUrl}${apiConfig.GetAdminWallet}`,
            );
            setWalletData({
                currentBalance: res.data.currentBalance || 0,
                holdBalance: res.data.holdBalance || 0,
                totalCredits: res.data.totalCredits || 0,
                totalDebits: res.data.totalDebits || 0,
                transactions: res.data.transactions || [],
            });
        } catch (error) {
            console.log("Wallet fetch error", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <div className="max-full mx-auto">
                {/* WALLET CARDS */}

                <div className="grid md:grid-cols-4 gap-6 mb-8">
                    <div className="bg-white p-6 rounded-xl shadow border-l-4 border-blue-500">
                        <p className="text-gray-500">Current Balance</p>
                        <h3 className="text-2xl font-bold text-blue-600 mt-2">
                            ₹{walletData.currentBalance}
                        </h3>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow border-l-4 border-yellow-500">
                        <p className="text-gray-500">Hold Balance</p>
                        <h3 className="text-2xl font-bold text-yellow-600 mt-2">
                            ₹{walletData.holdBalance}
                        </h3>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow border-l-4 border-green-500">
                        <p className="font-semibold text-gray-500">Total Credits</p>
                        <h3 className="text-2xl font-bold text-green-600 mt-2">
                            ₹{walletData.totalCredits}
                        </h3>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow border-l-4 border-red-500">
                        <p className="text-gray-500">Total Debits</p>
                        <h3 className="text-2xl font-bold text-red-600 mt-2">
                            ₹{walletData.totalDebits}
                        </h3>
                    </div>
                </div>

                {/* TRANSACTION TABLE */}

                <div className="bg-white p-6 rounded-xl shadow">
                    <h2 className="text-xl font-semibold mb-4">
                        Admin Wallet Transactions
                    </h2>

                    {loading ? (
                        <p>Loading...</p>
                    ) : walletData.transactions.length === 0 ? (
                        <p>No transactions found</p>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="p-3 text-left">Date</th>
                                        <th className="p-3 text-left">Type</th>
                                        <th className="p-3 text-left">Amount</th>
                                        <th className="p-3 text-left">Order ID</th>
                                        <th className="p-3 text-left">Seller Name</th>
                                        <th className="p-3 text-left">Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {walletData.transactions.map((txn) => (
                                        <tr key={txn._id} className="border-t">
                                            <td className="p-3">
                                                {new Date(txn.createdAt).toLocaleDateString()}
                                            </td>

                                            <td className="p-3">
                                                <span
                                                    className={`px-3 py-1 text-xs rounded text-white ${txn.type === "credit"
                                                        ? "bg-green-500"
                                                        : "bg-red-500"
                                                        }`}
                                                >
                                                    {txn.type}
                                                </span>
                                            </td>

                                            <td className="p-3 font-semibold">
                                                ₹{txn.amount || txn.commissionamount || 0}
                                            </td>

                                            <td className="p-3">{txn.orderID || "-"}</td>

                                            <td className="p-3">{txn.seller?.fullName || "-"}</td>

                                            <td className="p-3 text-gray-600">
                                                {txn.description || "-"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminWallet;

